var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pdf',{ref:"pdf",attrs:{"src":"/MESspecification.pdf"}})
}
var staticRenderFns = []

export { render, staticRenderFns }